// src/pages/StartScreen.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

function StartScreen() {
  const navigate = useNavigate();

  const handleStart = async () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
      const docRef = doc(db, 'kodeessens', user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        navigate('/myessence');
      } else {
        navigate('/create-essens', {
          state: {
            kodeord: '',
            kjennetegn: '',
            essensSetning: '',
            tilkallingsformel: ''
          }
        });
      }
    } else {
      console.warn('❗Bruker ikke logget inn');
      navigate('/user-login');
    }
  };

  const handleAdmin = () => {
    navigate('/admin-login'); // ✅ Oppdatert rute
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col justify-center items-center px-6 py-12 md:px-10 relative">
      {/* Admin-knapp i hjørnet */}
      <div className="absolute top-4 right-4">
        <button
          onClick={handleAdmin}
          className="text-black bg-blue-200 hover:bg-blue-300 text-sm font-semibold px-4 py-2 rounded"
        >
          Logg inn som admin
        </button>
      </div>

      <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-6">
        Velkommen til <span className="text-blue-400">Kode-Essens™</span>
      </h1>
      <p className="text-center text-gray-300 max-w-xl mb-10 text-lg md:text-xl">
        Din unike digitale signatur. Lag din identitet med kraft og klarhet.
      </p>

      <div className="flex flex-col gap-4 w-full max-w-xs">
        <button
          onClick={handleStart}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg transition duration-200"
        >
          Lag din egen Kode-Essens™
        </button>
      </div>
    </div>
  );
}

export default StartScreen;
